{
  "archive_task": "Archive task",
  "archive_task_confirm": "Are you sure you want to archive this task?",
  "change_status": "Change status",
  "create_task": "Create task",
  "description_placeholder": "Describe the task in details...",
  "edit_task": "Edit task",
  "from_employee": "From {name}",
  "mark_complete": "Mark complete",
  "mark_in_progress": "Mark in progress",
  "mark_todo": "Mark as to do",
  "more_tasks_for_you": "More tasks for you",
  "my_tasks": "My tasks",
  "notification_settings_tasks_caption": "When tasks are assigned to you or updated",
  "notification_settings_tasks_overdue_caption": "When your tasks become overdue",
  "permissions_create_description": "Ability to create tasks for other employees",
  "permissions_create_title": "Create tasks",
  "permissions_manage_all_description": "View, edit, and archive tasks of all employees",
  "permissions_manage_all_title": "Manage all tasks",
  "permissions_module_description": "Access to the tasks module",
  "permissions_module_title": "Tasks module",
  "related_employee": "Related employee",
  "section_empty_description_archive": "Tasks you send to archive will appear here.",
  "section_empty_description_assignee": "There are no tasks assigned to this employee.",
  "section_empty_description_done": "Completed tasks will appear here.",
  "section_empty_description_related": "There are no tasks related to this employee.",
  "section_empty_description_todo": "Tasks assigned to you will appear here.",
  "section_empty_title_archive": "No archived tasks",
  "section_empty_title_done": "No completed tasks yet",
  "section_empty_title_todo": "No tasks yet",
  "section_empty_title_watching": "No tasks you watch",
  "section_title_archived": "Archived",
  "section_title_completed": "Completed",
  "section_title_overdue": "Overdue",
  "overdue_alerts_sent_anyway": "Overdue alerts will be sent anyway",
  "overdue_alerts_sent_regardless": "Overdue alerts will be sent regardless of selected option",
  "section_title_todo": "To do",
  "section_title_watching": "Watching",
  "task": "Task",
  "task_action_and_assigned_to": "and assigned to {name}",
  "task_action_archived": "Archived",
  "task_action_completed": "Marked completed",
  "task_action_created": "Created",
  "task_action_started": "Marked in progress",
  "task_action_stopped": "Moved back to to do",
  "task_action_uncompleted": "Marked as to do",
  "task_action_updated": "Updated",
  "tasks_related_employee": "{tasks} with {employee} as the related employee",
  "task_status_completed": "Completed",
  "task_status_in_progress": "In progress",
  "task_status_todo": "To do",
  "tasks": "Tasks",
  "tasks_as_assignee": "Tasks",
  "tasks_as_related": "Related tasks",
  "tasks_feature_description": "Assign and track tasks for employees.",
  "tasks_overdue": "Overdue tasks",
  "things_to_do": "Things to do",
  "title_placeholder": "Write task name",
  "title_todo_count_prefix": "You've got",
  "title_todo_count_zero": "You're all caught up!",
  "view_task": "View task",
  "watcher": "Watcher",
  "watchers": "Watchers",
  "task_workflow_caption": "Flow automation",
  "task_action_created_by_workflow": "Created by flow",
  "from_workflow": "From {title} flow"
}
